__turbopack_context__.v({
  "arrow-right": "ArrowRight-module-scss-module__0ZmyAG__arrow-right",
});
